//首页历史数据
export const GET_HISTORY_INDEX_DATA = "get_history_index_data";
//请求首页历史
export const REQ_HISTORY_INDEX_DATA = "req_history_index_data";
